import { Map } from 'immutable';

export default Map({
  loading: false,
  taxAuthoritiesContacts: [],
  years: [],
  data: null,
  error: null,
});
